var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-auto ml-0 w-full lg:mr-3 mt-2 p-3 pt-0"},[_c('separation-type-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }